/**
 * Feature constants — mirrors BE App\Helpers\RezeptHistoryConstants.
 */

export const SEARCH_RADIO_INSURER_NAME = '1' as const;
export const SEARCH_RADIO_INSURER_TYPE = '2' as const;

export const REZEPT_KBN_MAIN = '1' as const;
export const REZEPT_KBN_RELATED = '2' as const;

export const SORT_BY_SERIAL = '1' as const;
export const SORT_BY_KANA = '2' as const;
export const SORT_BY_INSURER_NUMBER = '3' as const;

/** "無し" insurer type — ignored server-side even if user selects it. */
export const INSURER_TYPE_NONE_ID = 1;

export const LIST_PAGE_SIZE = 20;

// Validation / toast messages (legacy Japanese, matching BE constants).
export const YEARMONTH_REQUIRED_MESSAGE = '【提出年月】を入力してください';
export const YEARMONTH_FORMAT_MESSAGE = '【提出年月】を正しく入力してください';
export const VISITMONTH_FORMAT_MESSAGE = '日付を正しく入力してください。';
export const NO_SELECTION_MESSAGE = '対象のレセプトを選択してください。';
